/** Wizard state snapshot — taslak PATCH / restore için */

export const serializeWizardState = (state) => ({
  selectedOperation: state.selectedOperation || '',
  deviceNotSelected: Boolean(state.deviceNotSelected),
  deviceExplanation: state.deviceExplanation || '',
  selectedDeviceIds: (state.selectedDevices || []).map((d) => (
    typeof d === 'string' || typeof d === 'number' ? String(d) : (d.id || d._id)
  )).filter(Boolean),
  selectedAddressId: state.selectedAddress ? (state.selectedAddress.id || state.selectedAddress._id) : null,
  selectedFaultIds: (state.selectedFaults || []).map((f) => f.id || f._id).filter(Boolean),
  selectedFaultSnapshots: (state.selectedFaults || []).map((f) => {
    const id = f.id || f._id;
    if (!id) return null;
    const ad = f.icerikAdi || f.arizaAdi || f.ad || f.kategoriAdi || '';
    return {
      id: String(id),
      _id: String(id),
      icerikAdi: ad,
      arizaAdi: ad,
      ad,
    };
  }).filter(Boolean),
  faultNote: state.faultNote || '',
  selectedTechServiceIds: (state.selectedTechServices || []).map((t) => t.id || t._id).filter(Boolean),
  priority: state.priority || '',
  notes: state.notes || '',
  complaintCategory: state.complaintCategory || '',
  complaintNote: state.complaintNote || '',
  istekSikayetTuru: state.istekSikayetTuru || '',
  complaintTargetIcerikId: state.complaintTargetIcerikId || '',
  complaintTargetCihazId: state.complaintTargetCihazId || '',
  complaintTargetTechServiceId: state.complaintTargetTechServiceId || '',
  complaintTargetServisKaydiId: state.complaintTargetServisKaydiId || '',
  kurulumIcerikId: state.kurulumIcerikId || '',
  kurulumSeriNo: state.kurulumSeriNo || '',
  checklistCevaplari: state.checklistCevaplari || {},
  checklistDegerleri: state.checklistDegerleri || {},
  activeTab: state.activeTab || '',
  otpVarsayilanNumara: state.otpVarsayilanNumara !== false,
  otpAlternatifTelefon: state.otpAlternatifTelefon || '',
  odemeBeyaniChecked: Boolean(state.odemeBeyaniChecked),
});

export const getWizardStateSnapshot = (getters) => serializeWizardState({
  selectedOperation: getters.selectedOperation,
  deviceNotSelected: getters.deviceNotSelected,
  deviceExplanation: getters.deviceExplanation,
  selectedDevices: getters.selectedDevices,
  selectedAddress: getters.selectedAddress,
  selectedFaults: getters.selectedFaults,
  faultNote: getters.faultNote,
  selectedTechServices: getters.selectedTechServices,
  priority: getters.priority,
  notes: getters.notes,
  complaintCategory: getters.complaintCategory,
  complaintNote: getters.complaintNote,
  istekSikayetTuru: getters.istekSikayetTuru,
  complaintTargetIcerikId: getters.complaintTargetIcerikId,
  complaintTargetCihazId: getters.complaintTargetCihazId,
  complaintTargetTechServiceId: getters.complaintTargetTechServiceId,
  complaintTargetServisKaydiId: getters.complaintTargetServisKaydiId,
  kurulumIcerikId: getters.kurulumIcerikId,
  kurulumSeriNo: getters.kurulumSeriNo,
  checklistCevaplari: getters.checklistCevaplari,
  checklistDegerleri: getters.checklistDegerleri,
  activeTab: getters.activeTab,
  otpVarsayilanNumara: getters.otpVarsayilanNumara,
  otpAlternatifTelefon: getters.otpAlternatifTelefon,
  odemeBeyaniChecked: getters.odemeBeyaniChecked,
});

const summarizeCustomer = (customer) => {
  if (!customer) return null;
  const id = customer.id || customer._id;
  if (!id) return null;
  return {
    id: String(id),
    _id: String(id),
    adi: customer.adi || customer.name || '',
    soyadi: customer.soyadi || customer.surname || '',
    name: customer.name || customer.adi || '',
    surname: customer.surname || customer.soyadi || '',
    telefon: customer.telefon || customer.phone || '',
    phone: customer.phone || customer.telefon || '',
    iletisimIzni: customer.iletisimIzni || { verildi: false },
    odemeEksikSerhi: customer.odemeEksikSerhi || null,
  };
};

export const buildGeciciTaslakSnapshot = (getters) => ({
  version: 1,
  savedAt: Date.now(),
  meta: {
    isSantralFlow: Boolean(getters.isSantralFlow),
    gorusmeKaydiId: getters.gorusmeKaydiId || null,
    onServisKaydiId: getters.onServisKaydiId || null,
    santralTelefon: getters.santralTelefon || null,
    kaliciTaslakId: getters.kaliciTaslakId || null,
    activeTab: getters.activeTab || 'customer-search',
    maxAllowedTab: getters.maxAllowedTab || getters.activeTab || 'customer-search',
    selectedCustomer: summarizeCustomer(getters.selectedCustomer),
  },
  wizard: getWizardStateSnapshot(getters),
});

export const geciciTaslakHasContent = (snapshot) => {
  if (!snapshot?.wizard && !snapshot?.meta) return false;
  const w = snapshot.wizard || {};
  // İşlem tipi seçilmeden geçici/kalıcı taslak anlamlı değil
  if (!w.selectedOperation) return false;
  return true;
};
